

























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { MelosStation, MelosStationType } from '@/services/api.service';
import MelosInput from '@/components/MelosInput.vue';
import MelosButton from '@/components/MelosButton.vue';
import MelosButtonSet from '@/components/MelosButtonSet.vue';
import MelosCover from '@/components/MelosCover.vue';
import MelosMultipleToggle from '@/components/MelosMultipleToggle.vue';
import { MelosPlayerStatus } from '@/components/MelosPlayer.vue';

@Component({
  components: {
    MelosInput,
    MelosButton,
    MelosCover,
    MelosMultipleToggle,
    MelosButtonSet,
  },
})
export default class StationDetails extends Vue {
  private logoDateString = new Date().getTime();

  private async mounted() {
    if (this.stationData === undefined) {
      await this.fetchContent();
    }
  }

  private onOptionClick(index: number) {
    this.onLogoOptionClick(index);
  }

  private async onLogoOptionClick(index: number) {
    switch (index) {
      case 0:
        break;
      case 1:
        await this.$apiService.removeStationLogo(this.stationData._id || '');
        break;
    }
    this.logoDateString = new Date().getTime();
    this.fetchContent();
  }

  private async onThemeOptionClick(index: number) {
    switch (index) {
      case 0:
        break;
      case 1:
        this.$store.commit('setPlayerData', {
          audioSource: `https://api.melos.info/api/0.1/station/${this.stationData._id}/theme?t=${new Date().getTime()}`,
          waveformContent: await this.$apiService.getThemeWaveform(this.stationData._id || ''),
          provider: 'melos',
          author: undefined,
          imageSrc: undefined,
          link: undefined,
          stationId: undefined,
          trackDuration: await this.$apiService.getThemeDuration(this.stationData._id || ''),
          trackTitle: `${this.stationData.name} theme`,
          targetStatus: MelosPlayerStatus.PLAYING,
          targetElapsedTime: 0,
        });
        break;
      case 2:
        await this.$apiService.removeStationTheme(this.stationData._id || '');
    }
  }

  private async onLogoInputChanged() {
    const files = ((this.$refs.logoInput as any).files || []);
    if (files.length > 0) {
      const file = files[0];
      await this.$apiService.uploadStationLogo(this.stationData._id || '', file);
      this.logoDateString = new Date().getTime();
      this.fetchContent();
    }
  }

  private async onThemeInputChanged() {
    const files = ((this.$refs.themeInput as any).files || []);
    if (files.length > 0) {
      const file = files[0];
      await this.$apiService.uploadStationTheme(this.stationData._id || '', file);
    }
  }

  private async fetchContent() {
    const ownedStations = (await this.$apiService.getStations())
   .filter((station) => station.owner === this.$store.state.session?.userId);
    const ownedTracks = await this.$apiService.getTracks();
    this.$store.commit('setOwnedStations', ownedStations);
    this.$store.commit('setOwnedTracks', ownedTracks);
  }

  private get stationData(): MelosStation {
    return this.$store.state.ownedStations.find((station: MelosStation) => {
      return station._id === this.$route.params.stationId;
    });
  }

  @Watch('stationData.name')
  @Watch('stationData.show_to')
  @Watch('stationData.language')
  @Watch('stationData.period_config')
  @Watch('stationData.is_external')
  @Watch('stationData.uri')
  private async onStationChanged() {
    this.$store.commit('refreshOwnedStations');
    return this.$apiService.updateStation(this.stationData);
  }

  private get privateStation(): boolean {
    return this.stationData.type === MelosStationType.PRIVATE;
  }

  private set privateStation(isPrivate: boolean) {
    this.stationData.type = isPrivate ? MelosStationType.PRIVATE : MelosStationType.PUBLIC;
    this.onStationChanged();
  }

  private get token(): string {
    return this.$store.state.session?.token || '';
  }

  private toggleSchedule() {
    if (this.$route.name === 'stationDetails') {
      this.$router.replace({ path: `${this.stationData._id}/schedule` });
      return;
    }

    this.$router.replace({ path: `/stations/${this.stationData._id}` });
  }
}

